import { useMutation, useQuery } from '@tanstack/react-query';

import scheduleService from './reviewScheduleService';

import type { ReviewSchedule } from '@/types/review/ReviewSchedule';

import { queryClient } from '@/AppWithProviders';
import { ReviewQueryKey, ScheduleMutationKey, ScheduleQueryKey } from '@/constants/QueryKeys';

interface UseGetScheduleParams {
    scheduleId?: string;
    enabled?: boolean;
}

const useGetReviewSchedule = ({ scheduleId, enabled = false }: UseGetScheduleParams) => {
    return useQuery<ReviewSchedule>({
        queryKey: [ScheduleQueryKey.SCHEDULE, scheduleId],
        queryFn: () => scheduleService.getSchedule(scheduleId!),
        enabled,
    });
};

const useUpdateReviewSchedule = () => {
    return useMutation<ReviewSchedule, Error, ReviewSchedule>({
        mutationKey: [ScheduleMutationKey.UPDATE_SCHEDULE],
        mutationFn: (schedule: ReviewSchedule) => scheduleService.updateSchedule(schedule),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: [ReviewQueryKey.CYCLE_INSTANCE],
            });
        },
    });
};

export { useGetReviewSchedule, useUpdateReviewSchedule };
